import { renderToString } from "react-dom/server";
import Booklet_Entity from "./booklet";
export default class Booklet extends Booklet_Entity {
  static fromList(bookletsJSON: unknown): Array<Booklet> {
    const booklets: Booklet[] = [];
    if (bookletsJSON)
      Array.isArray(bookletsJSON) &&
        bookletsJSON.forEach((bookletJSON) => {
          booklets.push(new Booklet(bookletJSON));
        });
    return booklets;
  }

  toJson(): string {
    return JSON.stringify(this);
  }

  signed() {
    return this.locked ?? false;
  }

  dynamic(): string {
    return renderToString(
      <>
        <div
          className={`readonly-block booklet-${this.id}`}
          dangerouslySetInnerHTML={{
            __html: this.content,
          }}
        />
        <br />
      </>,
    );
  }
}
